import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MemberSubmission } from '../../../../models/submissions/member-submission';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { StatusPill } from '../../../../models/shared/status-pill';

@Component({
  selector: 'app-pending-submission-modal-card',
  templateUrl: './pending-submission-modal-card.component.html',
  styleUrls: ['./pending-submission-modal-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PendingSubmissionModalCardComponent implements OnChanges {
  @Input() submission!: MemberSubmission;
  @Input() submissionName: string | null = null;

  private _submission = new BehaviorSubject<MemberSubmission | null>(null);
  public submission$ = this._submission.exists();

  private _submissionName = new BehaviorSubject<string | null>(null);

  public submissionName$ = combineLatest([this.submission$, this._submissionName]).pipe(
    map(([sub, name]) => {
      return name ?? sub?.submissionTypeName;
    })
  );

  // Submission pills don't set a text colour, so match it to the border like the other status pills
  public submissionStatusPill$ = this.submission$.pipe(
    map(sub => {
      const pill = sub?.statusPill;
      if (!pill) return pill;
      return new StatusPill(pill.id, pill.name, pill.primaryColor, pill.secondaryColor, pill.primaryColor);
    })
  );

  public submissionOwner$ = this.submission$.pipe(
    map(sub => {
      return sub?.owner?.fullName;
    })
  );

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.submission) this._submission.next(this.submission);
    if (!!changes.submissionName) this._submissionName.next(this.submissionName);
  }
}
